import { useContext } from "react";
import { LanguageContext } from "../../context/LanguageContext";

function TitleMedium5Mobile() {
  const { translate } = useContext(LanguageContext);
  return (
    <div className="title-line-medium-mobile">
      <div
        className="title-medium5-block1-mobile font-mobile"
        style={{ flex: "0 0 33%" }}
      >
        {translate("GoogleEmail")}
      </div>
      <div
        className="title-medium5-block1-mobile font-mobile2"
        style={{ flex: "0 0 33%", textAlign: "center" }}
      >
        {translate("UserRole")}
      </div>
      <div
        className="title-medium5-block1-mobile font-mobile"
        style={{
          flex: "0 0 33%",
          textAlign: "right",
        }}
      >
        {translate("Actions")}
      </div>
    </div>
  );
}

export default TitleMedium5Mobile;
